import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Returning from Google OAuth: GoogleCallback exchanges the session first.
    if (window.location.hash?.includes("session_id=")) {
      setUser(false);
      return;
    }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const loginGoogle = async (session_id) => {
    const { data } = await api.post("/auth/google", { session_id });
    if (data.registration) return data;
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password, remember) => {
    const { data } = await api.post("/auth/login", { email, password, remember });
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, login, loginGoogle, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
